import { PaginationParams } from "@/services/api-service";
import { useSearchParams } from "react-router";

export const useUrlParams = <
  P extends PaginationParams = PaginationParams,
>() => {
  const [searchParams, setSearchParams] = useSearchParams();

  const getParams = (): P =>
    ({
      currentPage: Number(searchParams.get("currentPage")) || 1,
      pageSize: Number(searchParams.get("pageSize")) || 10,
      s: searchParams.get("s") || "",
      q: searchParams.get("q")?.trim() || "",
      ...Object.fromEntries(
        Array.from(searchParams.entries()).filter(
          ([key]) => !["currentPage", "pageSize", "s", "q"].includes(key),
        ),
      ),
    }) as P;

  const updateParams = (params: Partial<P>) => {
    const current = getParams();
    const newParams = {
      ...current,
      ...params,
    };

    const cleanParams = Object.fromEntries(
      Object.entries(newParams).filter(([key, value]) => {
        if (value === "") return false;
        if (value === "name:desc" && key === "s") return false;
        if (value === 1 && key === "currentPage") return false;
        if (value === 10 && key === "pageSize") return false;
        return true;
      }),
    );

    setSearchParams(
      Object.fromEntries(
        Object.entries(cleanParams).map(([key, value]) => [key, String(value)]),
      ),
    );
  };

  return {
    params: getParams(),
    updateParams,
  };
};
